import { render, staticRenderFns } from "./LastResultTabData.vue?vue&type=template&id=4b72f5ee&scoped=true"
import script from "./LastResultTabData.vue?vue&type=script&lang=js"
export * from "./LastResultTabData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b72f5ee",
  null
  
)

export default component.exports